import React from 'react';
const Header = () => {
  return (
      <div>
          <div className="sub-header">
              <div className="container">
                  <div className="row">
                      <div className="col-md-8 col-xs-12">
                          <ul className="left-info">
                              <li></li>
                              
                          </ul>
                      </div>
                      <div className="col-md-4">
                          <ul className="right-icons">
                              <li><a href="https://www.facebook.com/CreLab/?locale=fr_FR"><i className="fa fa-facebook"></i></a></li>
                              
                              <li><a href="mailto:creative.lab.club@gmail.com"><i className="fa fa-envelope"></i></a></li> 
                              <li><a href="https://www.instagram.com/creative_lab_isi/"><i className="fa fa-instagram"></i></a></li> 
                          </ul>
                      </div>
                  </div>
              </div>
          </div>

          <header className="">
              <nav className="navbar navbar-expand-lg">
                  <div className="container">
                      <a className="navbar-brand" href="./"><img src='../assets/images/logo.png' alt="Creative Lab"  width="60" height="60" /></a>
                      <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
                          <span className="navbar-toggler-icon"></span>
                      </button>
                      <div className="collapse navbar-collapse" id="navbarResponsive">
                          <ul className="navbar-nav ml-auto">
                              <li className="nav-item active">
                                  <a className="nav-link" href="/">Home
                                      <span className="sr-only">(current)</span>
                                  </a>
                              </li>
                              <li className="nav-item">
                                  <a className="nav-link" href="/AboutUs">About Us</a>
                              </li> 
                               <li className="nav-item">
                                   <a className="nav-link" href="/Events">Events</a>
                               </li>
                               <li className="nav-item">
                                   <a className="nav-link" href="/Timeline">Timeline</a>
                               </li>
                              <li className="nav-item">
                                  <a className="nav-link" href="/ContactUs">Contact Us</a>
                              </li>
                              <li className="nav-item">
                                  <a className="nav-link" href="/JoinUs"> Join Us</a>
                              </li>                        
                          </ul>
                      </div>
                  </div>
              </nav>
          </header>
      </div>
  );
};
export default Header;